import { Graphics, IEvent, ISpineData,ingenuity, SpineBase } from "@quest/base-core";
import { BaseViewBehavior } from "@quest/murka-games-behavior-leopard/dist";

export class WildDragonReelViewBG extends BaseViewBehavior {
  private wildMask: Graphics;

  /** Resize */
  protected resize(evt: IEvent): void {
    //
  }
  /**
   * to set mask
   */
  protected initializeComponents(): void {
    super.initializeComponents();
    this.addMask();
  }
  /**
   * 
   * to add mask to avoid wild look out of reel
   */
  private addMask(): void {
    this.wildMask = this.getShapeById("wildReelScreenMask") as Graphics;
    this.wildMask.position.x = this.json.maskPosX;
    this.wildMask.position.y = this.json.maskPosY;
    (this.getContainerByID("wildDragonOnReelMainContainer").mask as Graphics) = this.wildMask;
  }
  /**
* to clone spine
*/
  public cloneSpine(): SpineBase {
    let symbolIdleSpineObj: ISpineData = ingenuity.assetsData.getJSONById("main_data").wildDragonOnReel["WILD_1x4"];
    symbolIdleSpineObj.type = "spine";
    let SymbolSpineAnimClone: SpineBase = this.createSpine(symbolIdleSpineObj);
    SymbolSpineAnimClone.visible = true;
    this.setAnimationTransiton(SymbolSpineAnimClone)
    return SymbolSpineAnimClone;
  }

  /**
* Method to set animation transition mix for smotth transition
*/
  private setAnimationTransiton(SymbolSpineAnimClone: SpineBase): void {
    SymbolSpineAnimClone.stateData.setMix("static", "win", 0.5);
    SymbolSpineAnimClone.stateData.setMix("win", "static", 0.5);
    SymbolSpineAnimClone.stateData.setMix("static", "static", 0);
    // SymbolSpineAnimClone.stateData.setMix("wild_1x4_loop_pink_frame", "wild_1x4_action_2", 0); 
    // SymbolSpineAnimClone.stateData.setMix("wild_1x4_loop_pink_frame", "wild_1x4_action_3", 0);
    // SymbolSpineAnimClone.stateData.setMix("wild_1x4_action_1", "wild_1x4_loop_pink_frame", 0.5);
    // SymbolSpineAnimClone.stateData.setMix("wild_1x4_action_2", "wild_1x4_loop_pink_frame", 0.5); 
    // SymbolSpineAnimClone.stateData.setMix("wild_1x4_action_3", "wild_1x4_loop_pink_frame", 0.5);
  }
  /**
   * to reset dynamically created animations
   */
  public resetGlowAnimations(): void {
    this.json.getClowAnimCont.forEach((name: string) => {
      let container = this.getContainerByID(name)
      container && (container.removeAll());
      container && (container.children = []);
    })
  }

      /**
     * to reset all the wild dragon in the reel by hiding them
     */
      public resetWildDragon(): void {
        this.json.getWildAnimCont.forEach((name:string)=>{
            let container = this.getContainerByID(name);
            container && (container.removeAll());
            container && (container.children = []);
        })
    }
}